import React from 'react';
import cn from 'clsx';

import Link from '../../../../library/link/link';
import Typography from '../../../../library/typography/typography';
import FoundItLowerButton, {
  FoundItLowerTheme
} from '../../../../components/found-it-lower-button/found-it-lower-button';
import ParentProductMessage from '../../../../components/parent-product-message/parent-product-message';
import Price from '../../../../components/price/price';
import StackedMarkdownPrice from '../../../../components/stacked-markdown-price/stacked-markdown-price';

import { useFitment, useMediaQuery } from '../../../../shared/hooks/hooks';

import { isProductTrailerOrLawn } from '../../../../shared/utils/cart/cart';
import {
  getPriceInfo,
  isCanonicalProduct
} from '../../../../shared/utils/product/product';

import { ProductData } from '../../../../shared/types/graphql-types';

import styles from './product-list-card-price.scss';

interface ProductListCardPriceProps {
  className?: string;
  hideFoundItLower?: boolean;
  hideParentMessage?: boolean;
  hidePercentageSaved?: boolean;
  product?: ProductData;
  quantity: number;
  showStaticQuantity?: boolean;
  totalQuantity?: number;
}

function ProductListCardPrice(props: ProductListCardPriceProps) {
  const {
    className = '',
    hideFoundItLower = false,
    hideParentMessage = false,
    hidePercentageSaved = false,
    product,
    quantity,
    showStaticQuantity = false,
    totalQuantity
  } = props;

  const { isMinSm } = useMediaQuery();
  const { selectedFitment } = useFitment();

  if (!product) return null;

  const { unitName } = product;
  const isCanonical = isCanonicalProduct(product);
  const priceInfo = getPriceInfo(product);

  return (
    <div
      className={cn(
        styles['container'],
        `${className} "product-list-card-price"`
      )}
    >
      <div
        className={styles['price-line']}
        data-testid="product-list-card-price_line"
      >
        <StackedMarkdownPrice
          hidePercentageSaved={hidePercentageSaved}
          product={product}
        />
        <Price
          className={styles['price']}
          mapPrice={priceInfo?.mapPrice}
          price={priceInfo?.price}
          priceRange={priceInfo?.priceRange}
          unitName={unitName}
          variant="H3"
        />

        {showStaticQuantity && (
          <Typography className={styles['static-quantity']} tag="span">
            QTY: 4
          </Typography>
        )}
      </div>

      <div className={styles['found-it-lower-container']}>
        {!hideFoundItLower && (
          <FoundItLowerButton
            hideIcon={
              !isMinSm && process.env.__FF_PLP_CONDENSED_CARDS__ === 'true'
            }
            hideMatchItText={
              !isMinSm && process.env.__FF_PLP_CONDENSED_CARDS__ === 'true'
            }
            productItem={{
              product: product,
              quantity: quantity,
              totalQuantity: totalQuantity
            }}
            theme={
              process.env.__FF_PLP_CONDENSED_CARDS__ === 'true'
                ? FoundItLowerTheme.BLUE
                : FoundItLowerTheme.GREY
            }
          />
        )}
      </div>

      {!hideParentMessage && <ParentProductMessage product={product} />}

      {isCanonical && process.env.__FF_PLP_CONDENSED_CARDS__ !== 'true' && (
        <Typography
          className={styles['exact-price-msg']}
          size="small"
          tag="div"
        >
          {selectedFitment
            ? 'View details for price & inventory'
            : !isProductTrailerOrLawn(product) && (
                <>
                  <Link
                    className={styles['vehicle-link']}
                    size="small"
                    to="#/fitment/vehicle"
                  >
                    enter vehicle
                  </Link>{' '}
                  for exact price & inventory
                </>
              )}
        </Typography>
      )}
    </div>
  );
}

export default ProductListCardPrice;
